export class DatasetInfo {
    identifier: string | null = null;
    title: string | null = null;
    unit: string | null = null;
    groupTitle: string | null = null;
    groupId: number | null = null;
    companyId?: number | null = null;

    categoryTitle: string | null = null;
    categoryId: number | null = null;

    stringValueMapper: number | null = null;

    deviceId?: number | null = null;
    dataType: string | null = null;
    datasetClass: string | null = null;
    accessType: string | null = null;

    decimalPlaces: number | null = null;
    tags: string[] = []

    constructor(data: Partial<DatasetInfo>) {
        if (data) {
            Object.assign(this, data)
        }
    }

    toString(): string {
        let tmp = this.title || "";

        if (this.unit) {
            tmp += " | " + this.unit;
        }

        if (this.groupTitle) {
            tmp += " | " + this.groupTitle;
        }

        return tmp;
    }
}